module.exports = __webpack_public_path__ + "static/img/browser_version.0d197155.png";